'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndAlternateId } from '../../Entities/Ind/IndAlternateId';

export class IndAlternateIdRepository extends CoreRepository {
  public addIndAlternateIds(userId: number, payload: any[]) {
    return this.webAPI.addIndAlternateIds(userId, payload).then((response) => {
      return response;
    });
  }

  public getIndAlternateIds(userId: number, individualId: number) {
    return this.webAPI.getIndAlternateIds(userId, individualId).then((response) => {
      return response;
    });
  }

  public removeIndAlternateId(userId: number, individualId: number, alternateId: number) {
    return this.webAPI.removeIndAlternateId(userId, individualId, alternateId).then((response) => {
      return response;
    });
  }
}
